import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { AppConfig } from "./core/config/app.config";
import { WebStorage } from "./core/utility/web.storage";
import { TmpStorage } from "./core/utility/temp.storage";
import { Utills } from "./core/utility/utills";
import { HttpClient } from "./core/utility/http.client";
import { AuthGuard } from "./core/guards/auth.guard";
import { AuthService } from "./core/services/auth.service";
import { CRMService } from "./core/services/crm.service";
import { AuthInterceptor } from "./core/services/auth-interceptor";
import { PrivacyPolicyComponent } from "./modules/Global_Components/privacyPolicy.component";
import { OrderService } from "./core/services/order.service";
import { TruckingService } from "./core/services/trucking.service";
import { FileService } from "./core/services/file.service";

import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AppComponent } from "./modules/Global_Components/app.component";
import { AppRoutingModule } from "./app-routing.module";
import { LoginComponent } from "./modules/Global_Components/Login/login.component";
import { EmailverifyComponent } from "./modules/Global_Components/emailverify.component";
import { ForgotpasswordComponent } from "./modules/Global_Components/Forget_Password/forgotpassword.component";
import { ResetpasswordComponent } from "./modules/Global_Components/resetpassword.component";
import { PageNotFoundComponent } from "./pagenotfound.component";
import {
  DialogModule,
  ConfirmDialogModule,
  ProgressSpinnerModule
} from "primeng/primeng";
import { HttpClientModule } from "@angular/common/http";
import { VerifyAccountComponent } from "./modules/Global_Components/verifyAccount.component";
//Full calendar
import { FullCalendarModule } from "@fullcalendar/angular";
import { EventService } from "src/app/core/services/event.service";

import { ConfirmationService } from "primeng/primeng";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { TimepickerModule } from "ngx-bootstrap/timepicker";
import { AutoCompleteModule } from "primeng/autocomplete";
import { TooltipModule } from "ngx-bootstrap/tooltip";

import { Ng4LoadingSpinnerModule } from "ng4-loading-spinner";
// import { NgxLoaderSpinnerModule } from 'ngx-loader-spinner';
// import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import {CalendarModule as primengCalModule} from 'primeng/calendar';
import { HttpErrorInterceptor } from './core/utility/http-error.interceptor';
import { NgxSpinnerModule } from "ngx-spinner";


// import { BlockUIModule } from 'ng-block-ui';

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    LoginComponent,
    ForgotpasswordComponent,
    EmailverifyComponent,
    ResetpasswordComponent,
    PrivacyPolicyComponent,
    VerifyAccountComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      preventDuplicates: true
    }),
    HttpClientModule,
    AppRoutingModule,
    DialogModule,
    ConfirmDialogModule,
    ProgressSpinnerModule,
    FullCalendarModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    AutoCompleteModule,
    TooltipModule.forRoot(),
    Ng4LoadingSpinnerModule.forRoot(),
    primengCalModule,
    NgxSpinnerModule
    // BlockUIModule.forRoot()
  ],

  providers: [
    AppConfig,
    WebStorage,
    TmpStorage,
    Utills,
    HttpClient,
    AuthGuard,
    AuthService,
    CRMService,
    OrderService,
    ConfirmationService,
    TruckingService,
    FileService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    EventService
    // Ng4LoadingSpinnerService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
